export const defineKey = (key: string, _value?: string) => key;
